import { FormattedMessage } from 'react-intl';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { ANY_SPORT_MARKET_WHEEL } from '#src/constants/__generated__/routes.ts';
import { useEnabledWheelByRarity } from '#src/hooks/useEnabledWheelByRarity.ts';
import { generateSportPath } from '#src/lib/routing/generateSportPath.ts';

type Props = {
  nbTickets?: number;
  children?: React.ReactNode;
  sport?: Sport;
  onClick?: () => void;
};

export const SecondaryOrTickets = ({
  nbTickets = 2,
  sport,
  children,
  onClick,
}: Props): React.ReactNode => {
  const { limited } = useEnabledWheelByRarity();

  if (!sport || !limited || nbTickets === 0) {
    return children;
  }

  return (
    <Button
      to={generateSportPath(ANY_SPORT_MARKET_WHEEL, { sport })}
      color="transparent"
      fullWidth
      size="medium"
      onClick={onClick}
    >
      <FormattedMessage defaultMessage="Go Spin Now!" />
    </Button>
  );
};
